import * as Pages from "../pages"

import Plan from "components/menu/items/plan"

export const Sky_Retention_FTTP = {
  conditions: [1],
  conditionFunc: efsData => efsData.storeName === "Sky_Retention_FTTP",
  pages: [
    {
      pageComponent: Pages.SkyMarketingPage,
      menuItemText: "Welcome to Sky",
      appendStoreName: true
    },
    {
      pageComponent: Pages.SkyMarketingPage2,
      menuItemText: "Sky > Broadband",
      appendStoreName: true
    },
    {
      pageComponent: Pages.SelectPlanPage,
      menuItemComponent: Plan,
      menuItemText: "Shop > Choose a Plan",
      showDevice: true
    },
    {
      pageComponent: Pages.SummaryExtrasPage,
      menuItemComponent: null,
      menuItemText: "Shop > Your Basket"
    },
    {
      pageComponent: Pages.SummaryPage,
      menuItemComponent: null,
      menuItemText: "Shop > Your Basket > Summary"
    }
  ]
}
